import http from '../http-common'

const getAll = () => {
  return http.get('/account-types')
}

export const accountTypesService = {
  getAll,
}
